import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import * as React from 'react';

interface INoRowsOverlay {
  action?: React.ReactElement;
  headerText?: React.ReactElement | string;
  text?: React.ReactElement | string;
}

const NoRowsOverlay = ({ action, headerText, text }: INoRowsOverlay) => (
  <Box
    sx={{
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      justifyContent: 'center',
      mb: 6,
      mt: 9,
      mx: 3,
    }}
  >
    {headerText && (
      <Typography color="secondary" variant="h5">
        {headerText}
      </Typography>
    )}
    {text && (
      <Typography color="text.secondary" sx={{ mt: 3.5 }} textAlign="center" variant="body1">
        {text}
      </Typography>
    )}
    {action && <Box sx={{ mt: 3 }}>{action}</Box>}
  </Box>
);

export default NoRowsOverlay;
